export function knifeSwitch(ctx, node) {
    let i = node.rect.x
      , n = node.rect.y
      , r = node.rect.width
      , o = node.rect.height
      , s = r;
    return o < r && (s = o),
    ctx.beginPath(),
    ctx.strokeStyle = node.background,
    ctx.moveTo(i + r / 2 - s / 4, n),
    ctx.lineWidth = s / 6,
    ctx.rect(i + r / 2 - s / 4 + s / 12, n + s / 12, s / 3, 120 / 144 * s - s / 6),
    ctx.stroke(),
    ctx.closePath(),
    ctx.beginPath(),
    ctx.fillStyle = node.color,
    ctx.strokeStyle = node.color,
    ctx.lineWidth = 1,
    node.value ? ctx.rect(i + r / 2 - s / 36, n + 60 / 144 * s - .46875 * s, s / 18, .46875 * s) : ctx.rect(i + r / 2 - s / 36, n + 60 / 144 * s, s / 18, .46875 * s),
    ctx.stroke(),
    ctx.fill(),
    ctx.closePath(),
    ctx.beginPath(),
    node.value ? ctx.arc(i + r / 2, n + 60 / 144 * s - .46875 * s, 16 / 144 * s, 0, 2 * Math.PI) : ctx.arc(i + r / 2, n + 60 / 144 * s + .46875 * s, 16 / 144 * s, 0, 2 * Math.PI),
    ctx.stroke(),
    ctx.fill(),
    !1
}
